import * as React from "react";
import { useState } from "react";
import styled from "styled-components";
import { Button, Modal } from "components/bootstrap";
import { SelectedRowsProvider } from "common/contexts";
import { Row, Col } from "security-app/components/common/FormBaseStyles";
import { useListGitRepos } from "security-app/hooks/useSigmaAPI";
import EntityCreateShareFormGroup from "components/permissions/EntityCreateShareFormGroup";
import { Window } from "./styledComponents";
import LeftPanel from "./LeftPanel";
import RightPanel from "./RightPanel";
import ImportErrorsAlert from "./ImportErrorsAlert";
const StyledDiv = styled.div`
  display: block;
`;
const Buttons = ({ onCancel, importDisabled, setImportRules }) => /* @__PURE__ */ React.createElement(Row, { $width: "100%", $gap: "0.5rem", $justify: "flex-end", $align: "center" }, /* @__PURE__ */ React.createElement(Button, { type: "reset", form: "ruleOptions", onClick: onCancel }, "Cancel"), /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", disabled: importDisabled, onClick: () => setImportRules(true) }, "Import rules"));
function GitRulesModal({ onClose }) {
  const [shareRequest, setShareRequest] = useState(null);
  const [importRules, setImportRules] = useState(false);
  const [importErrors, setImportErrors] = useState([]);
  const [repo, setRepo] = useState(null);
  const { repos, loadingRepos } = useListGitRepos({ page: 1, perPage: 1e4 });
  return /* @__PURE__ */ React.createElement(Modal, { show: true, bsSize: "xlarge", onHide: onClose }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, /* @__PURE__ */ React.createElement("div", null, "Viewing: ", /* @__PURE__ */ React.createElement("small", null, (repo == null ? void 0 : repo.name) || "")))), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(Col, { $width: "100%" }, /* @__PURE__ */ React.createElement(SelectedRowsProvider, null, /* @__PURE__ */ React.createElement(Row, { $width: "100%", $align: "stretch", $justify: "stretch" }, /* @__PURE__ */ React.createElement(Window, { "data-testid": "navigator", $width: 45 }, /* @__PURE__ */ React.createElement(LeftPanel, { repo, setRepo, repos, loadingRepos })), /* @__PURE__ */ React.createElement(Window, { "data-testid": "selection", $width: 65 }, /* @__PURE__ */ React.createElement(
    RightPanel,
    {
      importRules,
      setImportRules,
      setImportErrors,
      closeModal: onClose,
      shareRequest
    }
  )))), importErrors.length > 0 && /* @__PURE__ */ React.createElement(ImportErrorsAlert, { importErrors, setImportErrors })), /* @__PURE__ */ React.createElement(StyledDiv, null, /* @__PURE__ */ React.createElement(
    EntityCreateShareFormGroup,
    {
      description: "Search for a User or Team to add as collaborator on this sigma rule.",
      entityType: "sigma_rule",
      onSetEntityShare: (payload) => setShareRequest(payload)
    }
  ))), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
    Buttons,
    {
      onCancel: onClose,
      importDisabled: importRules || importErrors.length > 0,
      setImportRules
    }
  )));
}
export default GitRulesModal;
